import React from 'react'
import './Toast.css'
import SuccessIcon from 'assets/icons/SuccessIcon'
import ToastErrorIcon from 'assets/icons/ToastErrorIcon'
import WarningAlertIcon from 'assets/icons/WarningAlertIcon'
import i18n from 'common/util/internationalization'
import applicationRouter from 'businesslayer/applicationRouter'
import {
    updatePregenerationAIMinutes,
    updateTranscriptAIMinutes
} from 'businesslayer/networkrequests'
import { updateWritingStyleAIMinutes } from 'businesslayer/networkrequests/AIStylesService'
import { PREGENERATION_DOCUMENT_STATUS, WRITING_STYLE_STATUS } from 'components/minutetaker/components/InvitationView/types'
import { translate } from 'components/shared/internationalization'
import { getLocalStorageItem } from 'businesslayer/minutesLocalStore'
import { getLocalizedLanguage } from 'common/util/langMap'
import { getTtmUrl } from 'common/util/urlMap'

import styled from '@emotion/styled'

const HelpCentre = styled('a')`
    color: #455d82;
    font-weight: 600;
    text-decoration: none;
`

const TranscriptToast = ({
    id,
    preGenPollingStatus,
    statusMessage,
    minuteInitiateUser,
    loggedInUser,
    MinutesTitle,
    removeToast
}) => {
    const status_Message = i18n.t(statusMessage)
    let userLang = getLocalStorageItem('userLanguage') || 'en'
    const localizedLang = getLocalizedLanguage(userLang)

    return (
        <>
            {minuteInitiateUser === loggedInUser ? (
                <div className={`custom-toast-ttm ${preGenPollingStatus}`}>
                    <div className="custom-toast-header">
                        <span className="custom-toast-icon">
                            {preGenPollingStatus ===
                            PREGENERATION_DOCUMENT_STATUS.UNAPPROVED_ERROR ? (
                                <ToastErrorIcon />
                            ) : preGenPollingStatus === PREGENERATION_DOCUMENT_STATUS.FAILED ? (
                                <ToastErrorIcon />
                            ) : preGenPollingStatus ===
                              PREGENERATION_DOCUMENT_STATUS.COMPLETE_MISMATCH ? (
                                <ToastErrorIcon />
                            ) : preGenPollingStatus ===
                              PREGENERATION_DOCUMENT_STATUS.PARTIAL_SUCCESS ? (
                                <WarningAlertIcon />
                            ) : preGenPollingStatus ===
                              PREGENERATION_DOCUMENT_STATUS.NO_SECTION ? (
                                <WarningAlertIcon />
                            ) : (
                                <SuccessIcon />
                            )}
                        </span>
                        <div style={{ flexDirection: 'column' }}>
                            <div className={`custom-toast-title-ttm ${preGenPollingStatus}`}>
                                {MinutesTitle}
                            </div>
                            <div className="custom-toast-message">
                                {status_Message}
                                <div>
                                    {(preGenPollingStatus ===
                                        PREGENERATION_DOCUMENT_STATUS.PARTIAL_SUCCESS ||
                                        preGenPollingStatus ===
                                            PREGENERATION_DOCUMENT_STATUS.COMPLETE_MISMATCH) && (
                                        <HelpCentre href={getTtmUrl(localizedLang)} target="blank">
                                            {i18n.t('HELP_CENTRE')}
                                        </HelpCentre>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className="custom-toast-border" />
                    <div className="custom-toast-buttons">
                        <button
                            className="dismiss"
                            onClick={() => {
                                updateTranscriptAIMinutes(id, preGenPollingStatus, false)
                                removeToast(id)
                            }}>
                            {translate('TOAST_DISMISS_BUTTON')}
                        </button>
                        <button
                            className="action"
                            onClick={() => {
                                updateTranscriptAIMinutes(id, preGenPollingStatus, false)
                                applicationRouter.navigateTo(`/taker/${id}`)
                            }}>
                            {preGenPollingStatus === PREGENERATION_DOCUMENT_STATUS.FAILED ||
                            preGenPollingStatus === PREGENERATION_DOCUMENT_STATUS.COMPLETE_MISMATCH
                                ? translate('BACK_TO_EDITOR')
                                : translate('VIEW')}
                        </button>
                    </div>
                </div>
            ) : null}
        </>
    )
}

const PregenerationToast = ({
    id,
    preGenPollingStatus,
    statusMessage,
    minuteInitiateUser,
    loggedInUser,
    MinutesTitle,
    removeToast
}) => {
    const status_Message = i18n.t(statusMessage)

    return (
        <>
            {minuteInitiateUser === loggedInUser ? (
                <div className={`custom-toast ${preGenPollingStatus}`}>
                    <div className="custom-toast-header">
                        <span className="custom-toast-icon">
                            {preGenPollingStatus ===
                                PREGENERATION_DOCUMENT_STATUS.UNAPPROVED_ERROR ||
                            preGenPollingStatus === PREGENERATION_DOCUMENT_STATUS.FAILED ||
                            preGenPollingStatus === PREGENERATION_DOCUMENT_STATUS.SUMMARY_FAILED ? (
                                <ToastErrorIcon />
                            ) : preGenPollingStatus ===
                              PREGENERATION_DOCUMENT_STATUS.PARTIAL_SUCCESS ? (
                                <WarningAlertIcon />
                            ) : (
                                <SuccessIcon />
                            )}
                        </span>
                        <div style={{ flexDirection: 'column' }}>
                            <div className={`custom-toast-title ${preGenPollingStatus}`}>
                                {MinutesTitle}
                            </div>
                            <div className="custom-toast-message">{status_Message}</div>
                        </div>
                    </div>
                    <hr className="custom-toast-border" />
                    <div className="custom-toast-buttons">
                        <button
                            className="dismiss"
                            onClick={() => {
                                updatePregenerationAIMinutes(id, preGenPollingStatus, false)
                                removeToast(id)
                            }}>
                            {translate('TOAST_DISMISS_BUTTON')}
                        </button>
                        <button
                            className="action"
                            onClick={() => {
                                updatePregenerationAIMinutes(id, preGenPollingStatus, false)
                                applicationRouter.navigateTo(`/taker/${id}`)
                            }}>
                            {translate('VIEW')}
                        </button>
                    </div>
                </div>
            ) : null}
        </>
    )
}

const WritingStyleToast = ({ id, preGenPollingStatus, errorType, removeToast, writingStyleId }) => {
    const isSuccess = preGenPollingStatus === WRITING_STYLE_STATUS.SUCCESS
    const isInvalidMinutes = preGenPollingStatus === WRITING_STYLE_STATUS.INVALID_MINUTES

    const isRestricted = preGenPollingStatus === WRITING_STYLE_STATUS.CONTENT_BLOCKED

    const getTitleKey = () => {
        if (isSuccess) return 'WRITING_STYLE_SUCCESS_TITLE'
        if (isRestricted) return 'WRITING_STYLE_CONTENT_BLOCKED_TITLE'
        return 'WRITING_STYLE_ERROR_TITLE'
    }

    const getMessageKey = () => {
        if (isSuccess) {
            return 'WRITING_STYLE_SUCCESS_MESSAGE'
        }
        if (isInvalidMinutes) {
            return 'WRITING_STYLE_CONTENT_ERROR_MESSAGE'
        }
        if (isRestricted) {
            return 'WRITING_STYLE_CONTENT_BLOCKED_ERROR'
        }
        return 'WRITING_STYLE_GENERAL_ERROR_MESSAGE'
    }

    const title = i18n.t(getTitleKey())
    const message = i18n.t(getMessageKey())
    const statusClass = isSuccess ? WRITING_STYLE_STATUS.SUCCESS : WRITING_STYLE_STATUS.FAILED

    const handleDismiss = () => {
        if (writingStyleId) {
            updateWritingStyleAIMinutes(writingStyleId)
        }
        removeToast(id)
    }

    return (
        <div className={`custom-toast-writing-style ${statusClass}`}>
            <div className="custom-toast-writing-style-header">
                <span className="custom-toast-writing-style-icon">
                    {isSuccess ? <SuccessIcon /> : <ToastErrorIcon />}
                </span>
                <div style={{ flexDirection: 'column' }}>
                    <div className={`custom-toast-writing-style-title ${statusClass}`}>
                        {title}
                    </div>
                    <div className="custom-toast-writing-style-message">{message}</div>
                </div>
            </div>
            <hr className="custom-toast-writing-style-border" />
            <div className="custom-toast-writing-style-buttons">
                <button
                    className="dismiss"
                    data-analytics="MM-WritingStyle_Dismiss_Button"
                    onClick={handleDismiss}>
                    {translate('DISMISS_BUTTON') || 'Dismiss'}
                </button>
            </div>
        </div>
    )
}

const StatusToast = (props) => {
    if (props.forWritingStyle) {
        return <WritingStyleToast {...props} />
    }
    return props.forTranscript ? <TranscriptToast {...props} /> : <PregenerationToast {...props} />
}

export default StatusToast
